var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{style:(' width:30px;height:30px; display:block; background:' + _vm.model + ';')})])
}
var staticRenderFns = []

export { render, staticRenderFns }